module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step6_img.138c7b06.svg";